export default "__VITE_ASSET__Bx8pfcTA__"